<template>
    <div class="row" v-if="steps != false">ippiippiip
        <b-col cols="10">
            <div>
                <span style="margin-right: 2rem;font-weight: 500; font-size:1.3rem;">Page {{current_step}} of {{steps.length}}</span>
                &nbsp;
                <b-button variant="secondary" style="margin-bottom: 0.4rem;" @click="previousStep()">Back</b-button>
                &nbsp;
                <b-button variant="success" style="margin-bottom: 0.4rem;" @click="nextStep()">Next</b-button>
                &nbsp;
                <b-button variant="success" style="margin-bottom: 0.4rem;" @click="$emit('back')">Home</b-button>
            </div>
        </b-col>
        <b-col cols="2"></b-col>
        <!-- --------------------------------------------------- -->
        <b-col cols="10">
            <div class="card" style="border: 1px solid lightgrey;">
                <div class="card-body">
                    <component v-if="stepComponent == 'form-plugin'" :uid="steps[current_step-1].uid" :is="stepComponent"/>
                    <component v-else :is="stepComponent"/> <!-- Pass in component name returned from db, in case of simple component this will be a predefined name of a component like simple.vue -->
                </div>
            </div>
        </b-col>
        <b-col cols="2"></b-col>
    </div>
</template>

<script>
export default {
    data:() => ({
        steps:[
            { id: 231, render_order: 1, component_name: "form-plugin", uid:"612747e7afafe" },
            { id: 312, render_order: 2, component_name: "form-plugin", uid:"61275acfb9dfd" },
            { id: 302, render_order: 3, component_name: "form-plugin", uid:"61278691ea6b1" },
            { id: 304, render_order: 4, component_name: "SimpleView" },
        ],
        current_step: 1,
    }),
    computed:{
        stepComponent() {
            let data = this.steps[this.current_step - 1].component_name;
            if(data == 'form-plugin'){
                return data;
            }
            else{
                return () => import(`../../components/steps/${data}`);
            }
        }
    },
    methods:{
        getConfig() {
          //config contains component type
          //if simple then render a set component like simpleStep.vue
          //if custom then render a custom component name passed in from the json dataset
        },
        nextStep(){
            if(this.current_step + 1 <= this.steps.length){
                this.current_step++;
            }
        },
        previousStep(){
            if(this.current_step - 1 != 0){
                this.current_step--;
            }
        }
    },
    mounted(){
        //this.steps = _.cloneDeep(this.step_data.spreadify_views);
    },
}
</script>

<style>

</style>